/* MAIYKO EKLENTI — Popüler Ek Ürünler (addon toggle) + Fiyatlı Sepete Ekle butonu
 *
 * Bağımsız: jQuery yok, harici bağımlılık yok, global kirliliği yok (tek IIFE).
 * Safari 15+ uyumlu (async/await, optional chaining ve ?? KULLANILMAZ).
 *
 * TEMEL GÜVENLİK KURALI:
 *   Hiçbir addon AÇIK DEĞİLKEN temanın kendi product-form.js akışına ASLA karışılmaz.
 *   Bu dosya sayfada yüklü olsa bile, hiçbir toggle açık değilse submit olayı
 *   hiç durdurulmadan temaya geçer.
 *
 * En az bir addon açıkken akış:
 *   1. Submit, document seviyesinde CAPTURE aşamasında yakalanır (böylece temanın
 *      form üzerindeki kendi dinleyicisinden ÖNCE çalışır) ve durdurulur.
 *   2. Açık addon'lar /cart/add.js adresine JSON items[] olarak eklenir.
 *   3. Başarılıysa aynı submit yeniden tetiklenir ve bu kez temaya geçirilir;
 *      ana ürünü ekleme, sections render, cart drawer/notification açma işlerini
 *      temanın kendi product-form.js'i YAPAR (davranış birebir korunur).
 *   4. Hata olursa temanın .product-form__error-message alanı kullanılır.
 *
 * STICKY ÇUBUK AYNALAMA:
 *   Fiyatlı buton her güncellendiğinde aynı içerik temanın sticky add-to-cart
 *   çubuğundaki (snippets/new-atc.liquid) eşleşen butonlara da yazılır. Sticky
 *   butonlar formun DIŞINDA durup form="..." ile bağlandığı için eşleşme bu
 *   nitelik üzerinden kurulur. Tükendi (disabled) butonlar ve metin yerine
 *   sepet SVG'si taşıyan ikon varyantı DIŞARIDA bırakılır.
 *
 * SAYFA KAYDIRMA (slider):
 *   Kartlar sayfalara bölünmüşse liste yatay kaydırılabilir bir konteynerde
 *   (CSS scroll-snap) durur; mobilde parmakla kaydırma bedavaya gelir. Alttaki
 *   ‹ › okları sayfa genişliği kadar kaydırır ve uçlarda disabled olur.
 *   prefers-reduced-motion açıkken yumuşak kaydırma yerine anlık atlama yapılır.
 *   Toggle dinleyicisi konteyner delegasyonuyla çalıştığı için kaydırılan
 *   sayfalardaki toggle'lar ve sepete ekleme akışı DEĞİŞMEDEN çalışır.
 *
 * NUMARA + RENK AÇILIR BUTONLARI:
 *   Kart, snippet'ten gelen <script type="application/json"> verisiyle kurulur.
 *   MENÜ NEREYE AÇILIR: kartın kendisine DEĞİL, .maiyko-addons kök elemanına.
 *   Sebep: kartların kapsayıcısı (.maiyko-addons__track) overflow-x:auto olduğu
 *   için overflow-y de "auto"ya düşer — karta absolute konumlanan bir menü orada
 *   KIRPILIR. Kök eleman position:relative olduğundan menü sayfa akışını
 *   bozmadan kartın altına yüzer ve kartla birlikte akar (position:fixed YOK;
 *   sticky çubuk gibi transform'lu atalar altında fixed yanlış konumlanır).
 *   Yatay kaydırma menüyü kartından ayıracağı için track scroll'unda menü kapanır.
 */
(function () {
  'use strict';

  if (window.MaiykoAddons) return;

  var MONEY_PLACEHOLDER = /\{\{\s*(\w+)\s*\}\}/;

  /* ------------------------------------------------------------------ */
  /* Para biçimlendirme (Shopify money_format uyumlu)                     */
  /* ------------------------------------------------------------------ */

  function formatWithDelimiters(cents, precision, thousands, decimal) {
    if (typeof precision !== 'number') precision = 2;
    if (typeof thousands !== 'string') thousands = ',';
    if (typeof decimal !== 'string') decimal = '.';
    if (isNaN(cents) || cents === null) return '0';

    var number = (cents / 100.0).toFixed(precision);
    var parts = number.split('.');
    var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var frac = parts[1] ? decimal + parts[1] : '';
    return whole + frac;
  }

  function formatMoney(cents, format, hideZeroDecimals) {
    var formatString = format || '{{amount}}';
    var match = formatString.match(MONEY_PLACEHOLDER);
    if (!match) return formatString;

    var value;
    switch (match[1]) {
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ', ',');
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', ',');
        break;
      case 'amount_with_period_and_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    // Mağaza ayarı "kuruşsuz göster" ise ve kuruş 0 ise ondalık kısmı at.
    if (hideZeroDecimals && cents % 100 === 0) {
      value = value.replace(/[.,]0{2}$/, '');
    }

    return formatString.replace(MONEY_PLACEHOLDER, value);
  }

  /* ------------------------------------------------------------------ */
  /* Yardımcılar                                                         */
  /* ------------------------------------------------------------------ */

  function toInt(value, fallback) {
    var n = parseInt(value, 10);
    return isNaN(n) ? fallback : n;
  }

  function parseJSONAttr(el, name, fallback) {
    var raw = el.getAttribute(name);
    if (!raw) return fallback;
    try {
      return JSON.parse(raw);
    } catch (e) {
      return fallback;
    }
  }

  function cartAddUrl() {
    if (window.routes && window.routes.cart_add_url) return window.routes.cart_add_url;
    return '/cart/add.js';
  }

  /**
   * Bir butonun METİN taşıyan ilk span'ı (doğrudan çocuk).
   * Yükleniyor çarkı butonun KARDEŞ elemanıdır; bazı temalarda span olarak
   * geldiği için sınıf adına bakıp eleriz — çark asla ezilmemeli.
   */
  function firstLabelSpan(button) {
    var kids = button.children;
    for (var i = 0; i < kids.length; i++) {
      var el = kids[i];
      if (el.nodeName !== 'SPAN') continue;
      if (el.classList && (el.classList.contains('loading__spinner') || el.classList.contains('spinner'))) {
        continue;
      }
      return el;
    }
    return null;
  }

  /* ------------------------------------------------------------------ */
  /* Kayıt defteri                                                       */
  /* ------------------------------------------------------------------ */

  var addonControllers = [];
  var atcControllers = [];

  function addonControllerForForm(form) {
    for (var i = 0; i < addonControllers.length; i++) {
      if (addonControllers[i].form === form) return addonControllers[i];
    }
    return null;
  }

  /* ------------------------------------------------------------------ */
  /* 1) Addon toggle listesi — custom element                            */
  /* ------------------------------------------------------------------ */

  function AddonController(el) {
    this.el = el;
    this.busy = false;
    this.passThrough = false;
    this.form = null;
    this.resolveForm();

    var self = this;
    // NOT: change dinleyicisi KONTEYNERE bağlanır (delegasyon). Kartlar sayfalara
    // bölünmüş olsa da hepsi bu elemanın altındadır; kaydırılan sayfalardaki
    // toggle'lar da bu yüzden aynen çalışır.
    this.onChange = function (evt) {
      var input = evt.target;
      if (!input || !input.classList || !input.classList.contains('maiyko-switch__input')) return;
      var row = input.closest('[data-maiyko-addon]');
      if (row) row.classList.toggle('is-on', input.checked);
      syncAtc();
    };
    this.el.addEventListener('change', this.onChange);

    this.track = this.el.querySelector('[data-maiyko-track]');
    this.prevBtn = this.el.querySelector('[data-maiyko-prev]');
    this.nextBtn = this.el.querySelector('[data-maiyko-next]');
    this.navRaf = 0;
    this.setupSlider();

    this.secimler = [];
    this.setupSecim();

    addonControllers.push(this);
  }

  /* ---- Sayfa kaydırma (slider) ---------------------------------------- */

  AddonController.prototype.reducedMotion = function () {
    if (!window.matchMedia) return false;
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  };

  /** Bir sayfanın piksel genişliği (sayfa = konteyner genişliği). */
  AddonController.prototype.pageWidth = function () {
    if (!this.track) return 0;
    var page = this.track.querySelector('.maiyko-addons__page');
    if (page && page.offsetWidth) return page.offsetWidth;
    return this.track.clientWidth;
  };

  AddonController.prototype.maxScroll = function () {
    if (!this.track) return 0;
    var max = this.track.scrollWidth - this.track.clientWidth;
    return max > 0 ? max : 0;
  };

  /** dir: +1 sonraki sayfa, -1 önceki sayfa. */
  AddonController.prototype.scrollToPage = function (dir) {
    if (!this.track) return;
    var width = this.pageWidth();
    if (!width) return;

    var track = this.track;
    var start = track.scrollLeft;
    var current = Math.round(start / width);
    var target = (current + dir) * width;
    var max = this.maxScroll();
    if (target < 0) target = 0;
    if (target > max) target = max;
    if (Math.abs(target - start) < 1) return;

    // prefers-reduced-motion açıkken yumuşak kaydırma yerine anlık atla.
    if (this.reducedMotion()) {
      track.scrollLeft = target;
      this.updateNav();
      return;
    }

    try {
      track.scrollTo({ left: target, behavior: 'smooth' });
    } catch (e) {
      track.scrollLeft = target;
    }

    // GÜVENLİK AĞI: bazı ortamlarda (otomasyon tarayıcıları, animasyonu kapatan
    // kurulumlar) "smooth" kaydırma isteği SESSİZCE YOK SAYILIR — liste hiç
    // kımıldamaz. Kısa süre sonra hâlâ yerinden oynamadıysa anlık kaydırmaya düş.
    var self = this;
    window.setTimeout(function () {
      if (Math.abs(track.scrollLeft - start) < 1) {
        track.scrollLeft = target;
      }
      self.updateNav();
    }, 300);
  };

  /** Uçlardaki okları devre dışı bırak. */
  AddonController.prototype.updateNav = function () {
    if (!this.track) return;
    if (!this.prevBtn && !this.nextBtn) return;
    var x = this.track.scrollLeft;
    var max = this.maxScroll();
    var EPS = 2; // alt piksel yuvarlama payı
    if (this.prevBtn) this.prevBtn.disabled = x <= EPS;
    if (this.nextBtn) this.nextBtn.disabled = x >= max - EPS;
  };

  AddonController.prototype.setupSlider = function () {
    if (!this.track) return;
    var self = this;

    // Oklar type="button" olduğu için form submit tetiklemez; yine de delegasyon
    // kullanıyoruz ki SVG içine tıklama da yakalansın.
    this.onNavClick = function (evt) {
      var target = evt.target;
      if (!target || typeof target.closest !== 'function') return;
      var btn = target.closest('[data-maiyko-prev], [data-maiyko-next]');
      if (!btn || !self.el.contains(btn)) return;
      evt.preventDefault();
      self.scrollToPage(btn.hasAttribute('data-maiyko-next') ? 1 : -1);
    };
    this.el.addEventListener('click', this.onNavClick);

    // Scroll olayı rAF ile throttle edilir.
    this.onScroll = function () {
      // Menü kök elemana konumlandığı için yatay kaydırma onu kartından ayırır.
      if (acikMenu) menuKapat();
      if (self.navRaf) return;
      self.navRaf = window.requestAnimationFrame(function () {
        self.navRaf = 0;
        self.updateNav();
      });
    };
    this.track.addEventListener('scroll', this.onScroll);

    this.onResize = function () {
      self.updateNav();
    };
    window.addEventListener('resize', this.onResize);

    this.updateNav();
  };

  AddonController.prototype.resolveForm = function () {
    var formId = this.el.getAttribute('data-maiyko-form');
    var form = null;
    if (formId) form = document.getElementById(formId);
    if (!form) {
      var host = this.el.closest('.shopify-section') || document;
      form = host.querySelector('product-form form');
    }
    this.form = form;
  };

  AddonController.prototype.destroy = function () {
    if (acikMenu && acikMenu.kok === this.el) menuKapat();
    for (var s = 0; s < this.secimler.length; s++) this.secimler[s].destroy();
    this.secimler.length = 0;
    this.el.removeEventListener('change', this.onChange);
    if (this.onNavClick) this.el.removeEventListener('click', this.onNavClick);
    if (this.track && this.onScroll) this.track.removeEventListener('scroll', this.onScroll);
    if (this.onResize) window.removeEventListener('resize', this.onResize);
    if (this.navRaf) {
      window.cancelAnimationFrame(this.navRaf);
      this.navRaf = 0;
    }
    var idx = addonControllers.indexOf(this);
    if (idx > -1) addonControllers.splice(idx, 1);
  };

  /** Açık olan addon'ların {id, quantity} listesi. Hiçbiri açık değilse boş dizi. */
  AddonController.prototype.selectedItems = function () {
    var items = [];
    var rows = this.el.querySelectorAll('[data-maiyko-addon]');
    for (var i = 0; i < rows.length; i++) {
      var input = rows[i].querySelector('.maiyko-switch__input');
      if (!input || !input.checked) continue;
      var id = toInt(rows[i].getAttribute('data-maiyko-variant-id'), 0);
      if (!id) continue;
      items.push({ id: id, quantity: 1 });
    }
    return items;
  };

  /** Açık addon'ların fiyat toplamı ve orijinal (üstü çizili) toplamı — kuruş. */
  AddonController.prototype.selectedTotals = function () {
    var total = 0;
    var compare = 0;
    var rows = this.el.querySelectorAll('[data-maiyko-addon]');
    for (var i = 0; i < rows.length; i++) {
      var input = rows[i].querySelector('.maiyko-switch__input');
      if (!input || !input.checked) continue;
      var price = toInt(rows[i].getAttribute('data-maiyko-price'), 0);
      var orig = toInt(rows[i].getAttribute('data-maiyko-compare'), 0);
      total += price;
      compare += orig > price ? orig : price;
    }
    return { total: total, compare: compare };
  };

  AddonController.prototype.errorWrapper = function () {
    var host = this.form ? this.form.closest('product-form') : null;
    if (!host) host = this.el.closest('.shopify-section');
    if (!host) return null;
    return host.querySelector('.product-form__error-message-wrapper');
  };

  AddonController.prototype.showError = function (message) {
    var wrapper = this.errorWrapper();
    if (!wrapper) {
      if (message) console.error('[maiyko] ' + message);
      return;
    }
    var target = wrapper.querySelector('.product-form__error-message');
    if (message) {
      if (target) target.textContent = message;
      wrapper.removeAttribute('hidden');
    } else {
      wrapper.setAttribute('hidden', '');
    }
  };

  AddonController.prototype.spinner = function (on) {
    if (!this.form) return;
    var button = this.form.querySelector('[type="submit"]');
    if (!button) return;
    button.classList.toggle('loading', !!on);
    var spinner = button.querySelector('.loading__spinner');
    if (spinner) spinner.classList.toggle('hidden', !on);
  };

  /**
   * Addon'ları ekler, ardından aynı submit'i temaya geçirir.
   * Ana ürünü sepete ekleme + drawer/notification açma işini TEMA yapar.
   */
  AddonController.prototype.addAddonsThenSubmit = function (form, items) {
    var self = this;
    this.busy = true;
    this.showError(false);
    this.spinner(true);

    fetch(cartAddUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: items })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok || (result.data && result.data.status)) {
          var msg =
            (result.data && (result.data.description || result.data.message)) ||
            'Ek ürün sepete eklenemedi.';
          self.showError(msg);
          self.spinner(false);
          self.busy = false;
          return;
        }

        // Ana ürünü temanın kendi akışı eklesin.
        self.busy = false;
        self.passThrough = true;
        self.spinner(false);

        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else {
          form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        }
      })
      .catch(function (e) {
        console.error('[maiyko] addon ekleme hatası', e);
        self.showError('Ek ürün sepete eklenemedi. Lütfen tekrar deneyin.');
        self.spinner(false);
        self.busy = false;
      });
  };

  /* ------------------------------------------------------------------ */
  /* 1b) Numara + Renk açılır butonları                                  */
  /* ------------------------------------------------------------------ */

  /* Sayfada AYNI ANDA yalnız bir menü açık olabilir. */
  var acikMenu = null;

  function menuKapat() {
    if (!acikMenu) return;
    var m = acikMenu;
    acikMenu = null;
    if (m.btn) {
      m.btn.setAttribute('aria-expanded', 'false');
      if (m.btn.classList) m.btn.classList.remove('is-acik');
    }
    if (m.menu && m.menu.parentNode) m.menu.parentNode.removeChild(m.menu);
  }

  /**
   * Bir varyant/ürün başlığındaki İLK sayıyı döndürür.
   * "20 (12 cm)" -> "20", "Krem / 20 (12 cm)" -> "20", "9-12 Ay" -> "9".
   * Ana ürünün numarasıyla addon numarasını eşlemek için kullanılır.
   */
  function numaraCek(metin) {
    if (!metin) return '';
    var parcalar = String(metin).split('/');
    for (var i = 0; i < parcalar.length; i++) {
      var m = parcalar[i].replace(/^\s+/, '').match(/^(\d+)/);
      if (m) return m[1];
    }
    return '';
  }

  /**
   * Ürün başlığından renk adı türetir (snippets/maiyko-renk-secici.liquid ile
   * AYNI algoritma; düşülecek kelime kümesi Liquid'den "|a|b|" biçiminde gelir).
   * Kalan İLK 1-2 BİTİŞİK kelime renk adı sayılır.
   * NOT: küçük harfe çevirme Liquid'in "downcase" filtresiyle aynı davransın diye
   * yerel ayarsız toLowerCase() ile yapılır (tr-TR "İ" -> "i" farkı istenmiyor).
   */
  function renkAdiTuret(baslik, drop) {
    if (!baslik) return '';
    if (!drop) drop = '|';
    var kelimeler = String(baslik).replace(/[,\-/]/g, ' ').split(' ');
    var renk = '';
    var alinan = 0;
    var oncekiIdx = -1;
    for (var i = 0; i < kelimeler.length; i++) {
      if (alinan >= 2) break;
      var k = kelimeler[i].replace(/^\s+|\s+$/g, '');
      if (!k) continue;
      if (drop.indexOf('|' + k.toLowerCase() + '|') > -1) continue;
      if (alinan === 0) {
        renk = k;
        alinan = 1;
        oncekiIdx = i;
      } else {
        if (i - oncekiIdx === 1) renk = renk + ' ' + k;
        alinan = 2;
      }
    }
    return renk;
  }

  function stokluVaryantlar(liste) {
    var out = [];
    if (!liste) return out;
    for (var i = 0; i < liste.length; i++) {
      if (liste[i] && liste[i].a) out.push(liste[i]);
    }
    return out;
  }

  /** Buton etiketinde gösterilecek KISA numara ("20 (12 cm)" -> "20"). */
  function kisaNumara(baslik) {
    if (!baslik) return '';
    return String(baslik).split(' ')[0];
  }

  function KartSecim(kart, veri, ctrl) {
    this.kart = kart;
    this.veri = veri;
    this.ctrl = ctrl;
    this.kok = ctrl.el;
    this.drop = veri.d || '|';

    this.numBtn = kart.querySelector('[data-maiyko-sec="numara"]');
    this.renkBtn = kart.querySelector('[data-maiyko-sec="renk"]');
    this.input = kart.querySelector('.maiyko-switch__input');
    this.anahtar = kart.querySelector('.maiyko-switch');

    this.kendiIdx = 0;
    this.uyeler = this.uyeListesiKur();
    this.aktifIdx = this.kendiIdx;
    this.aktifVar = toInt(kart.getAttribute('data-maiyko-variant-id'), 0);

    this.baglan();
    this.onSecim();
    this.yenile();
  }

  /**
   * Kartın KENDİ ürününü bir "üye" kaydına çevirir. Ağır alanlar (başlık, görsel,
   * fiyat) snippet'ten tekrar basılmaz; başlangıç DOM'undan okunur.
   */
  KartSecim.prototype.kendiUye = function () {
    var kart = this.kart;
    var img = kart.querySelector('.maiyko-addon__img--1');
    var basl = kart.querySelector('.maiyko-addon__title');
    var fiyat = kart.querySelector('.maiyko-addon__price');
    var karsi = kart.querySelector('.maiyko-addon__compare');
    var rozet = kart.querySelector('.maiyko-addon__badge');
    var kaynak = img ? img.getAttribute('src') : '';
    return {
      i: this.veri.c || 0,
      n: this.veri.n || '',
      s: this.veri.s || kaynak || '',
      m: kaynak || '',
      t: basl ? basl.textContent.replace(/^\s+|\s+$/g, '') : '',
      a: 1,
      p: fiyat ? fiyat.innerHTML : '',
      o: karsi ? karsi.innerHTML : '',
      b: rozet ? rozet.textContent.replace(/^\s+|\s+$/g, '') : '',
      pc: toInt(kart.getAttribute('data-maiyko-price'), 0),
      oc: toInt(kart.getAttribute('data-maiyko-compare'), 0),
      v: this.veri.v || []
    };
  };

  KartSecim.prototype.uyeListesiKur = function () {
    var kendi = this.kendiUye();
    var grup = this.veri.g;
    if (!grup || !grup.length) {
      this.kendiIdx = 0;
      return [kendi];
    }
    var out = [];
    var bulundu = false;
    for (var i = 0; i < grup.length; i++) {
      var u = grup[i];
      if (!u) continue;
      if (u.k) {
        // Snippet kartın kendi ürününü {"i":..,"k":1} olarak işaretler.
        bulundu = true;
        this.kendiIdx = out.length;
        out.push(kendi);
        continue;
      }
      if (!u.v) u.v = [];
      out.push(u);
    }
    if (!bulundu) {
      // Kart ürünü grupta yoksa (metafield eksik/farklı) listenin başına eklenir.
      out.unshift(kendi);
      this.kendiIdx = 0;
    }
    return out;
  };

  KartSecim.prototype.aktifUye = function () {
    return this.uyeler[this.aktifIdx] || this.uyeler[0];
  };

  KartSecim.prototype.uyeAdi = function (uye) {
    if (!uye) return '';
    if (uye.n) return uye.n;
    return renkAdiTuret(uye.t, this.drop);
  };

  /* ---- Kart içeriğini yazan yardımcılar ---- */

  KartSecim.prototype.rozetYaz = function (metin, tukendi) {
    var satir = this.kart.querySelector('.maiyko-addon__pricerow');
    var rozet = this.kart.querySelector('.maiyko-addon__badge');
    if (!metin) {
      if (rozet) rozet.setAttribute('hidden', '');
      return;
    }
    if (!rozet) {
      if (!satir) return;
      rozet = document.createElement('span');
      rozet.className = 'maiyko-addon__badge';
      satir.appendChild(rozet);
    }
    rozet.removeAttribute('hidden');
    rozet.textContent = metin;
    if (rozet.classList) rozet.classList.toggle('maiyko-addon__badge--tukendi', !!tukendi);
  };

  /**
   * Fiyat paketini (p/o/b/pc/oc) karta uygular.
   * money_format mağazanın KENDİ ayarıdır ve Liquid de aynı dizgeyi HTML olarak
   * basar; bu yüzden burada innerHTML kullanmak ek bir güven sınırı aşmaz.
   */
  KartSecim.prototype.fiyatYaz = function (paket) {
    if (!paket || typeof paket.pc !== 'number' || !paket.p) return;
    var satir = this.kart.querySelector('.maiyko-addon__pricerow');
    var fiyat = this.kart.querySelector('.maiyko-addon__price');
    if (fiyat) fiyat.innerHTML = paket.p;

    this.kart.setAttribute('data-maiyko-price', String(paket.pc));
    this.kart.setAttribute('data-maiyko-compare', String(paket.oc || 0));

    var karsi = this.kart.querySelector('.maiyko-addon__compare');
    if (paket.o) {
      if (!karsi && satir) {
        karsi = document.createElement('s');
        karsi.className = 'maiyko-addon__compare';
        var rozet = satir.querySelector('.maiyko-addon__badge');
        if (rozet) satir.insertBefore(karsi, rozet);
        else satir.appendChild(karsi);
      }
      if (karsi) {
        karsi.innerHTML = paket.o;
        karsi.removeAttribute('hidden');
      }
    } else if (karsi) {
      karsi.setAttribute('hidden', '');
    }

    this.rozetYaz(paket.b || '', false);
  };

  /**
   * Renk değişince ikinci ürün görseli artık geçerli değildir; geçiş kalıcı olarak
   * kapatılır (ilk renge geri dönülse bile geri gelmez — bilinçli sadeleştirme).
   */
  KartSecim.prototype.gorselGecisiKapat = function () {
    var alan = this.kart.querySelector('.maiyko-addon__media');
    if (!alan) return;
    alan.removeAttribute('data-maiyko-addon-fade');
    if (alan.classList) alan.classList.remove('is-alt');
    var img2 = this.kart.querySelector('.maiyko-addon__img--2');
    if (img2 && img2.parentNode) img2.parentNode.removeChild(img2);
  };

  KartSecim.prototype.varyantUygula = function (v) {
    if (!v) return;
    this.aktifVar = v.i;
    this.kart.setAttribute('data-maiyko-variant-id', String(v.i));
    if (this.input) this.input.value = String(v.i);
    // Varyantın kendi fiyat paketi yoksa üyenin taban paketine dönülür.
    this.fiyatYaz(typeof v.pc === 'number' && v.p ? v : this.aktifUye());
  };

  /* ---- Buton etiketleri + tükendi durumu ---- */

  KartSecim.prototype.yenile = function () {
    var uye = this.aktifUye();
    var vs = uye.v || [];
    var stoklu = stokluVaryantlar(vs);
    var stokVar = stoklu.length > 0;

    if (this.kart.classList) this.kart.classList.toggle('maiyko-addon--tukendi', !stokVar);

    if (this.input) {
      this.input.disabled = !stokVar;
      if (!stokVar && this.input.checked) {
        this.input.checked = false;
        if (this.kart.classList) this.kart.classList.remove('is-on');
      }
    }

    if (this.numBtn) {
      // Tek numaralı modelde numara butonu HİÇ görünmez.
      if (vs.length > 1) this.numBtn.removeAttribute('hidden');
      else this.numBtn.setAttribute('hidden', '');
      this.numBtn.disabled = !stokVar;
      var nd = this.numBtn.querySelector('[data-maiyko-sec-deger]');
      if (nd) {
        var secili = null;
        // Stok yokken karttaki eski varyant hâlâ eşleşebilir; o yüzden önce stoğa bakılır.
        if (stokVar) {
          for (var i = 0; i < vs.length; i++) {
            if (vs[i].i === this.aktifVar) {
              secili = vs[i];
              break;
            }
          }
        }
        nd.textContent = secili ? kisaNumara(secili.t) : '—';
      }
    }

    if (this.renkBtn) {
      var rd = this.renkBtn.querySelector('[data-maiyko-sec-deger]');
      if (rd) rd.textContent = stokVar ? this.uyeAdi(uye) : 'Başka renk seç';
      var mini = this.renkBtn.querySelector('[data-maiyko-sec-mini]');
      if (mini) {
        var img = mini.querySelector('img');
        if (!stokVar) {
          mini.setAttribute('hidden', '');
        } else {
          mini.removeAttribute('hidden');
          if (img && uye.s) img.setAttribute('src', uye.s);
        }
      }
    }

    if (!stokVar) this.rozetYaz('Stokta yok', true);
  };

  /* ---- Ana üründen numara ön-seçimi (YALNIZ ilk kurulumda) ---- */

  KartSecim.prototype.onSecim = function () {
    var ham = this.kok.getAttribute('data-maiyko-ana-varyant') || '';
    var num = numaraCek(ham);
    var vs = this.aktifUye().v || [];
    var hedef = null;
    var i;
    if (num) {
      for (i = 0; i < vs.length; i++) {
        if (vs[i].a && numaraCek(vs[i].t) === num) {
          hedef = vs[i];
          break;
        }
      }
    }
    if (!hedef) {
      for (i = 0; i < vs.length; i++) {
        if (vs[i].a) {
          hedef = vs[i];
          break;
        }
      }
    }
    if (!hedef || hedef.i === this.aktifVar) return;
    this.varyantUygula(hedef);
  };

  /* ---- Seçim eylemleri ---- */

  KartSecim.prototype.numaraSec = function (idx) {
    var vs = this.aktifUye().v || [];
    var v = vs[idx];
    if (!v || !v.a) return;
    this.varyantUygula(v);
    this.yenile();
    syncAtc();
  };

  KartSecim.prototype.renkSec = function (idx) {
    var uye = this.uyeler[idx];
    if (!uye) return;
    // Stoksuz renk seçilemez (menüde soluk + "Stok tükendi" etiketiyle durur).
    if (!stokluVaryantlar(uye.v).length) return;
    if (idx === this.aktifIdx) return;

    this.aktifIdx = idx;

    var basl = this.kart.querySelector('.maiyko-addon__title');
    if (basl && uye.t) basl.textContent = uye.t;

    var img = this.kart.querySelector('.maiyko-addon__img--1');
    if (img && uye.m) img.setAttribute('src', uye.m);
    this.gorselGecisiKapat();

    if (this.input && uye.t) {
      this.input.setAttribute('aria-label', uye.t + ' ürününü siparişe ekle');
    }

    this.fiyatYaz(uye);

    // Numara listesi yeni modelin stoğuna göre yenilenir: ilk müsait numara seçilir.
    var vs = uye.v || [];
    for (var i = 0; i < vs.length; i++) {
      if (vs[i].a) {
        this.varyantUygula(vs[i]);
        break;
      }
    }

    this.yenile();
    syncAtc();
  };

  /* ---- Menü ---- */

  KartSecim.prototype.menuAc = function (tip) {
    var self = this;
    var btn = tip === 'renk' ? this.renkBtn : this.numBtn;
    if (!btn) return;

    var menu = document.createElement('div');
    menu.className = 'maiyko-secmenu';
    menu.setAttribute('role', 'listbox');

    var bas = document.createElement('div');
    bas.className = 'maiyko-secmenu__baslik';
    bas.textContent = tip === 'renk' ? 'Renk — aynı gruptaki modeller' : 'Numara';
    menu.appendChild(bas);

    var kayitlar = tip === 'renk' ? this.uyeler : this.aktifUye().v || [];
    for (var i = 0; i < kayitlar.length; i++) {
      menu.appendChild(this.ogeKur(tip, kayitlar[i], i));
    }

    this.onOge = function (evt) {
      var t = evt.target;
      if (!t || typeof t.closest !== 'function') return;
      if (!menu.contains(t)) return;
      // Menü İÇİ tıklama belgeye sızmasın (dışa-tık dinleyicisi menüyü kapatır).
      evt.stopPropagation();
      var oge = t.closest('[data-maiyko-oge]');
      if (!oge) return;
      evt.preventDefault();
      if (oge.getAttribute('data-maiyko-yok') === '1') return;
      var idx = toInt(oge.getAttribute('data-maiyko-oge'), -1);
      menuKapat();
      if (idx < 0) return;
      if (tip === 'renk') self.renkSec(idx);
      else self.numaraSec(idx);
    };
    menu.addEventListener('click', this.onOge);
    menu.addEventListener('keydown', function (evt) {
      if (evt.key !== 'Enter' && evt.key !== ' ') return;
      self.onOge(evt);
    });

    this.kok.appendChild(menu);
    this.konumla(menu, btn);

    btn.setAttribute('aria-expanded', 'true');
    if (btn.classList) btn.classList.add('is-acik');
    acikMenu = { menu: menu, btn: btn, kok: this.kok, sahip: this };
  };

  KartSecim.prototype.ogeKur = function (tip, kayit, idx) {
    var oge = document.createElement('div');
    var sinif = 'maiyko-secmenu__oge';
    var stokVar;
    var etiket;

    if (tip === 'renk') {
      stokVar = stokluVaryantlar(kayit.v).length > 0;
      etiket = this.uyeAdi(kayit);
      if (kayit.s) {
        var kutu = document.createElement('span');
        kutu.className = 'maiyko-secmenu__mini';
        var img = document.createElement('img');
        img.setAttribute('src', kayit.s);
        img.setAttribute('alt', '');
        img.setAttribute('width', '34');
        img.setAttribute('height', '34');
        img.setAttribute('loading', 'lazy');
        kutu.appendChild(img);
        oge.appendChild(kutu);
      }
      if (idx === this.aktifIdx) sinif += ' maiyko-secmenu__oge--secili';
    } else {
      stokVar = !!kayit.a;
      etiket = kayit.t || '';
      if (kayit.i === this.aktifVar) sinif += ' maiyko-secmenu__oge--secili';
    }

    if (!stokVar) {
      sinif += ' maiyko-secmenu__oge--yok';
      oge.setAttribute('data-maiyko-yok', '1');
      oge.setAttribute('aria-disabled', 'true');
    }

    var ad = document.createElement('span');
    ad.className = 'maiyko-secmenu__ad';
    ad.textContent = etiket;
    oge.appendChild(ad);

    if (!stokVar) {
      var uyari = document.createElement('span');
      uyari.className = 'maiyko-secmenu__yok';
      uyari.textContent = 'Stok tükendi';
      oge.appendChild(uyari);
    } else if (sinif.indexOf('--secili') > -1) {
      var tik = document.createElement('span');
      tik.className = 'maiyko-secmenu__tik';
      tik.textContent = '✓';
      oge.appendChild(tik);
    }

    oge.className = sinif;
    oge.setAttribute('role', 'option');
    oge.setAttribute('aria-selected', sinif.indexOf('--secili') > -1 ? 'true' : 'false');
    oge.setAttribute('data-maiyko-oge', String(idx));
    oge.setAttribute('tabindex', stokVar ? '0' : '-1');
    return oge;
  };

  /**
   * Menü kök elemana (position:relative) absolute konumlanır; ölçüler kartın ve
   * butonun rect'lerinden çıkarılır. jsdom gibi düzen hesaplamayan ortamlarda tüm
   * değerler 0 gelir — hata vermez, yalnız konum anlamsız olur.
   */
  KartSecim.prototype.konumla = function (menu, btn) {
    if (!this.kok.getBoundingClientRect || !btn.getBoundingClientRect) return;
    var kokR = this.kok.getBoundingClientRect();
    var kartR = this.kart.getBoundingClientRect();
    var btnR = btn.getBoundingClientRect();
    if (!kokR || !kartR || !btnR) return;
    menu.style.top = btnR.bottom - kokR.top + 6 + 'px';
    menu.style.left = kartR.left - kokR.left + 'px';
    if (kartR.width) menu.style.width = kartR.width + 'px';
  };

  /* ---- Bağlama / yıkım ---- */

  KartSecim.prototype.baglan = function () {
    var self = this;

    this.onBtn = function (evt) {
      var t = evt.target;
      if (!t || typeof t.closest !== 'function') return;
      var btn = t.closest('[data-maiyko-sec]');
      if (!btn || !self.kart.contains(btn)) return;
      evt.preventDefault();
      // Belge seviyesindeki "dışa tıklama" dinleyicisi menüyü hemen kapatmasın.
      evt.stopPropagation();
      if (btn.disabled) return;
      var zatenAcik = acikMenu && acikMenu.btn === btn;
      menuKapat();
      if (!zatenAcik) self.menuAc(btn.getAttribute('data-maiyko-sec'));
    };
    this.kart.addEventListener('click', this.onBtn);

    // Tükendi kartta toggle pasiftir; tık kabuğa düşer ve kısa bir uyarı verilir.
    this.onAnahtar = function () {
      if (!self.kart.classList) return;
      if (!self.kart.classList.contains('maiyko-addon--tukendi')) return;
      self.kart.classList.add('is-uyari');
      window.setTimeout(function () {
        if (self.kart.classList) self.kart.classList.remove('is-uyari');
      }, 900);
    };
    if (this.anahtar) this.anahtar.addEventListener('click', this.onAnahtar);
  };

  KartSecim.prototype.destroy = function () {
    if (acikMenu && acikMenu.sahip === this) menuKapat();
    this.kart.removeEventListener('click', this.onBtn);
    if (this.anahtar && this.onAnahtar) this.anahtar.removeEventListener('click', this.onAnahtar);
  };

  AddonController.prototype.setupSecim = function () {
    // Ayar kapalıysa snippet bu niteliği HİÇ basmaz -> yeni davranışın tamamı susar.
    if (this.el.getAttribute('data-maiyko-secim') !== '1') return;
    var kartlar = this.el.querySelectorAll('[data-maiyko-addon]');
    for (var i = 0; i < kartlar.length; i++) {
      var blok = kartlar[i].querySelector('script[data-maiyko-secim-veri]');
      if (!blok) continue;
      var veri = null;
      try {
        veri = JSON.parse(blok.textContent || '{}');
      } catch (e) {
        veri = null;
      }
      if (!veri || !veri.v) continue;
      this.secimler.push(new KartSecim(kartlar[i], veri, this));
    }
  };

  /* Menüyü kapatan genel olaylar — dosya başına BİR kez bağlanır. */
  document.addEventListener('click', function () {
    if (acikMenu) menuKapat();
  });

  document.addEventListener('keydown', function (evt) {
    if (!acikMenu) return;
    if (evt.key === 'Escape' || evt.key === 'Esc') menuKapat();
  });

  window.addEventListener('resize', function () {
    if (acikMenu) menuKapat();
  });

  if (!window.customElements.get('maiyko-addon-toggles')) {
    window.customElements.define(
      'maiyko-addon-toggles',
      class MaiykoAddonToggles extends HTMLElement {
        connectedCallback() {
          if (this.maiykoController) return;
          this.maiykoController = new AddonController(this);
          syncAtc();
        }

        disconnectedCallback() {
          if (this.maiykoController) {
            this.maiykoController.destroy();
            this.maiykoController = null;
          }
        }
      }
    );
  }

  /* ------------------------------------------------------------------ */
  /* 2) Fiyatlı "Sepete Ekle" butonu                                     */
  /* ------------------------------------------------------------------ */

  function AtcController(button) {
    this.button = button;
    this.form = button.form || button.closest('form');
    this.variants = {};

    var list = parseJSONAttr(button, 'data-maiyko-variants', []);
    for (var i = 0; i < list.length; i++) {
      this.variants[String(list[i].id)] = list[i];
    }

    this.moneyFormat = button.getAttribute('data-maiyko-money-format') || '{{amount}}';
    this.hideZeros = button.getAttribute('data-maiyko-hide-zeros') === 'true';
    this.label = button.getAttribute('data-maiyko-label') || '';
    this.showArrow = button.getAttribute('data-maiyko-arrow') === 'true';
    this.inner = button.querySelector('.maiyko-atc__inner');
    this.writing = false;

    var self = this;
    // Tema, varyant değişiminde [name="add"] > span içeriğini textContent ile
    // ezebiliyor (Dawn toggleAddButton). Silinirse yeniden kuruyoruz.
    this.observer = new MutationObserver(function () {
      if (self.writing) return;
      if (self.inner && self.inner.querySelector('[data-maiyko-atc-total]')) return;
      self.update();
    });
    this.observer.observe(button, { childList: true, subtree: true });

    atcControllers.push(this);
  }

  AtcController.prototype.destroy = function () {
    if (this.observer) this.observer.disconnect();
    var idx = atcControllers.indexOf(this);
    if (idx > -1) atcControllers.splice(idx, 1);
  };

  AtcController.prototype.currentVariant = function () {
    if (!this.form) return null;
    var input = this.form.querySelector('[name="id"]');
    if (!input) return null;
    return this.variants[String(input.value)] || null;
  };

  AtcController.prototype.quantity = function () {
    if (!this.form) return 1;
    var input = this.form.querySelector('[name="quantity"]');
    if (!input) return 1;
    return Math.max(1, toInt(input.value, 1));
  };

  /** Bu butonun bağlı olduğu formun kimliği (sticky butonlar form="..." taşır).
      DİKKAT: this.form.id KULLANILMAZ — Shopify ürün formunda <input name="id">
      bulunduğu için form.id o input ELEMENTİNİ döndürür (named property
      gölgelemesi); kimlik her zaman öznitelikten okunmalıdır. */
  AtcController.prototype.formId = function () {
    var attr = this.button.getAttribute('form');
    if (attr) return attr;
    if (this.form && typeof this.form.getAttribute === 'function') {
      var kimlik = this.form.getAttribute('id');
      if (kimlik) return kimlik;
    }
    return '';
  };

  /**
   * Sticky çubuktaki, BU denetleyicinin formuna ait submit butonları.
   * Tema editöründe section yeniden yüklendiğinde sticky DOM'u baştan kurulur;
   * bu yüzden referans SAKLANMAZ, her çağrıda taze sorgulanır.
   */
  AtcController.prototype.stickyTargets = function () {
    var all = document.querySelectorAll('.sticky-atc .sticky-atc-button');
    var out = [];
    if (!all.length) return out; // Sticky çubuk kapalı → sessizce geç.

    var id = this.formId();
    var host = null;
    if (!id && typeof this.button.closest === 'function') {
      host = this.button.closest('.shopify-section');
    }

    for (var i = 0; i < all.length; i++) {
      var btn = all[i];
      if (id) {
        var btnForm = btn.getAttribute('form');
        if (btnForm) {
          if (btnForm !== id) continue;
        } else if (btn.form !== this.form) {
          // form niteliği yoksa DOM sahipliğine bak.
          continue;
        }
      } else if (!host || !host.contains(btn)) {
        // Form kimliği hiç çözülemediyse yalnız aynı section içindekine dokun.
        continue;
      }
      out.push(btn);
    }
    return out;
  };

  /** Ana butonun içeriğini sticky çubuktaki eşleşen butonlara aynala. */
  AtcController.prototype.mirrorSticky = function () {
    if (!this.inner) return;
    var targets = this.stickyTargets();

    for (var i = 0; i < targets.length; i++) {
      var btn = targets[i];
      // Tükendi durumunda temanın yazdığı metne DOKUNMA.
      if (btn.hasAttribute('disabled') || btn.getAttribute('aria-disabled') === 'true') continue;

      var span = firstLabelSpan(btn);
      if (!span) continue;

      var mirror = span.querySelector('[data-maiyko-sticky-mirror]');
      if (!mirror) {
        // Metinsiz ikon varyantı (span içinde yalnız sepet SVG'si) olduğu gibi kalır.
        // Bu SVG testi YALNIZ henüz aynalanmamış span'da geçerlidir: aynaladıktan
        // sonra ok ikonu yüzünden span'da SVG bulunur, o yüzden önce işaret aranır.
        if (span.querySelector('svg')) continue;
        span.textContent = '';
        mirror = document.createElement('span');
        mirror.className = 'maiyko-atc__inner';
        mirror.setAttribute('data-maiyko-sticky-mirror', '');
        span.appendChild(mirror);
      }

      // İçerik bu dosyanın ürettiği sabit şablon; etiket ve fiyatlar textContent
      // ile yazıldığı için innerHTML kopyası ek kaçış riski taşımaz.
      mirror.innerHTML = this.inner.innerHTML;
    }
  };

  AtcController.prototype.update = function () {
    var button = this.button;

    // Tükendi / yükleniyor durumunda temanın yazdığı metne DOKUNMA.
    if (button.hasAttribute('disabled') || button.getAttribute('aria-disabled') === 'true') return;

    var variant = this.currentVariant();
    if (!variant) return;

    var qty = this.quantity();
    var total = variant.price * qty;
    var compare = (variant.compare > variant.price ? variant.compare : variant.price) * qty;

    var addons = addonControllerForForm(this.form);
    if (addons) {
      var sums = addons.selectedTotals();
      total += sums.total;
      compare += sums.compare;
    }

    var html = '';
    if (this.showArrow) {
      html +=
        '<span class="maiyko-atc__arrow" aria-hidden="true">' +
        '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
        '<path d="M4 12h15M13 6l6 6-6 6" stroke="currentColor" stroke-width="2" ' +
        'stroke-linecap="round" stroke-linejoin="round"/></svg></span>';
    }
    if (this.label) {
      html += '<span class="maiyko-atc__label"></span>';
      html += '<span class="maiyko-atc__sep" aria-hidden="true">-</span>';
    }
    html += '<span class="maiyko-atc__total" data-maiyko-atc-total></span>';
    html += '<s class="maiyko-atc__compare" data-maiyko-atc-compare hidden></s>';

    this.writing = true;
    if (!this.inner || !this.inner.isConnected) {
      this.inner = button.querySelector('.maiyko-atc__inner');
    }
    if (!this.inner) {
      this.writing = false;
      return;
    }
    this.inner.innerHTML = html;

    var labelEl = this.inner.querySelector('.maiyko-atc__label');
    if (labelEl) labelEl.textContent = this.label;

    var totalEl = this.inner.querySelector('[data-maiyko-atc-total]');
    if (totalEl) totalEl.textContent = formatMoney(total, this.moneyFormat, this.hideZeros);

    var compareEl = this.inner.querySelector('[data-maiyko-atc-compare]');
    if (compareEl) {
      if (compare > total) {
        compareEl.textContent = formatMoney(compare, this.moneyFormat, this.hideZeros);
        compareEl.removeAttribute('hidden');
      } else {
        compareEl.textContent = '';
        compareEl.setAttribute('hidden', '');
      }
    }
    this.writing = false;

    // Sticky çubuk açıksa aynı içeriği oraya da bas (ilk kurulumda da çalışır).
    this.mirrorSticky();
  };

  function syncAtc() {
    for (var i = 0; i < atcControllers.length; i++) {
      atcControllers[i].update();
    }
  }

  /* ------------------------------------------------------------------ */
  /* Submit yakalama (document CAPTURE — temadan ÖNCE çalışır)           */
  /* ------------------------------------------------------------------ */

  function onSubmitCapture(evt) {
    var form = evt.target;
    if (!form || form.nodeName !== 'FORM') return;

    var ctrl = addonControllerForForm(form);
    if (!ctrl) return;

    // Addon'lar eklendi, bu submit temaya ait.
    if (ctrl.passThrough) {
      ctrl.passThrough = false;
      return;
    }

    // İşlem sürerken çift gönderimi engelle.
    if (ctrl.busy) {
      evt.preventDefault();
      evt.stopPropagation();
      return;
    }

    var items = ctrl.selectedItems();
    if (!items.length) return; // Hiç addon açık değil → temaya HİÇ karışma.

    evt.preventDefault();
    evt.stopPropagation();
    ctrl.addAddonsThenSubmit(form, items);
  }

  /* ------------------------------------------------------------------ */
  /* Başlatma / yeniden tarama                                           */
  /* ------------------------------------------------------------------ */

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;

    var buttons = scope.querySelectorAll('[data-maiyko-atc]');
    for (var i = 0; i < buttons.length; i++) {
      if (buttons[i].maiykoAtc) continue;
      buttons[i].maiykoAtc = new AtcController(buttons[i]);
    }

    // Custom element henüz upgrade olmadıysa (nadiren) elle bağla.
    var lists = scope.querySelectorAll('maiyko-addon-toggles');
    for (var j = 0; j < lists.length; j++) {
      if (!lists[j].maiykoController) {
        lists[j].maiykoController = new AddonController(lists[j]);
      }
    }

    syncAtc();
  }

  function cleanup(root) {
    if (!root || !root.querySelectorAll) return;
    var buttons = root.querySelectorAll('[data-maiyko-atc]');
    for (var i = 0; i < buttons.length; i++) {
      if (buttons[i].maiykoAtc) {
        buttons[i].maiykoAtc.destroy();
        buttons[i].maiykoAtc = null;
      }
    }
  }

  document.addEventListener('submit', onSubmitCapture, true);

  // Varyant / adet değişimi: değer okuma payload'dan bağımsız yapılır.
  document.addEventListener('change', function (evt) {
    var t = evt.target;
    if (!t || typeof t.closest !== 'function') return;
    if (
      t.name === 'id' ||
      t.name === 'quantity' ||
      t.closest('product-form, variant-radios, variant-selects')
    ) {
      setTimeout(syncAtc, 0);
    }
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function () {
      setTimeout(syncAtc, 0);
    });
    subscribe(PUB_SUB_EVENTS.quantityUpdate, function () {
      setTimeout(syncAtc, 0);
    });
  }

  /* ------------------------------------------------------------------
     Ek ürün kartlarında 1. ve 2. görsel arası yumuşak geçiş.
     TEK interval tüm kartları yönetir; kaydırma (stagger) CSS'teki
     transition-delay ile yapılır, ek zamanlayıcı kurulmaz.
     - Sekme görünmüyorsa (document.hidden) atlanır.
     - prefers-reduced-motion açıksa zamanlayıcı HİÇ kurulmaz.
     - Kart kalmazsa interval kendini kapatır.
     ------------------------------------------------------------------ */
  var MAIYKO_FADE_MS = 3000;
  var maiykoFadeTimer = null;

  function maiykoAzHareket() {
    try {
      return !!(
        window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches
      );
    } catch (e) {
      return false;
    }
  }

  function maiykoFadeBaslat() {
    if (maiykoFadeTimer || maiykoAzHareket()) return;
    if (typeof window.setInterval !== 'function') return;

    maiykoFadeTimer = window.setInterval(function () {
      var alanlar = document.querySelectorAll('[data-maiyko-addon-fade]');
      if (!alanlar || !alanlar.length) {
        window.clearInterval(maiykoFadeTimer);
        maiykoFadeTimer = null;
        return;
      }
      if (document.hidden) return;
      for (var i = 0; i < alanlar.length; i++) {
        if (alanlar[i].classList) alanlar[i].classList.toggle('is-alt');
      }
    }, MAIYKO_FADE_MS);
  }

  document.addEventListener('shopify:section:load', function (evt) {
    scan(evt.target);
    maiykoFadeBaslat();
  });

  document.addEventListener('shopify:section:unload', function (evt) {
    cleanup(evt.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan(document);
      maiykoFadeBaslat();
    });
  } else {
    scan(document);
    maiykoFadeBaslat();
  }

  window.MaiykoAddons = {
    scan: scan,
    sync: syncAtc,
    formatMoney: formatMoney
  };
})();
